import { Link } from "react-router-dom";
import { CheckCircle2, Repeat, Info } from "lucide-react";
import { socialMediaPlan } from "@/config/site";

// Monthly social-media subscription offering – sits below the 3 main packages
// on /pakiety and on the homepage. Matches the visual style of package cards.
export const SocialPlanCard = ({ testidPrefix = "social-plan" }) => {
    return (
        <div className="mt-12 max-w-5xl mx-auto rounded-[20px] bg-white border border-[#E5E7EB] overflow-hidden" data-testid={`${testidPrefix}-card`}>
            <div className="grid md:grid-cols-5">
                <div className="md:col-span-2 bg-gradient-to-br from-[#06111F] to-[#0F172A] text-white p-7 md:p-8 relative overflow-hidden">
                    <div className="absolute inset-0 bg-grid-faint opacity-40" />
                    <div className="relative">
                        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#14B8A6]/15 border border-[#14B8A6]/40 text-[#14B8A6] text-[11px] font-semibold uppercase tracking-wider mb-4">
                            <Repeat className="w-3 h-3" /> Abonament miesięczny
                        </div>
                        <h3 className="font-display font-semibold text-2xl md:text-3xl leading-tight">{socialMediaPlan.name}</h3>
                        <div className="mt-3 text-[#14B8A6] font-display font-bold text-2xl md:text-3xl">{socialMediaPlan.priceFrom}</div>
                        <p className="mt-4 text-[#AAB6C5] text-[15px] leading-relaxed">{socialMediaPlan.description}</p>
                    </div>
                </div>
                <div className="md:col-span-3 p-7 md:p-8 flex flex-col">
                    <h4 className="font-semibold text-sm uppercase tracking-wider text-[#0B1220]/60 mb-4">Zakres usługi</h4>
                    <ul className="space-y-2.5 text-[14px] text-[#0B1220]/85 flex-1">
                        {socialMediaPlan.features.map((f) => (
                            <li key={f} className="flex gap-2.5">
                                <CheckCircle2 className="w-4 h-4 text-[#14B8A6] flex-shrink-0 mt-0.5" />
                                <span>{f}</span>
                            </li>
                        ))}
                    </ul>
                    <div className="mt-5 flex items-start gap-2 text-xs text-[#0B1220]/60 rounded-[12px] bg-[#F6F8FA] border border-[#E5E7EB] px-3 py-2.5">
                        <Info className="w-3.5 h-3.5 flex-shrink-0 mt-0.5 text-[#14B8A6]" />
                        <span>{socialMediaPlan.note}</span>
                    </div>
                    <Link
                        to={`/kontakt?package=${encodeURIComponent(socialMediaPlan.contactValue)}`}
                        data-testid={`${testidPrefix}-cta`}
                        className="mt-5 inline-flex items-center justify-center self-start px-6 py-3 rounded-[12px] bg-[#14B8A6] hover:bg-[#0EA5A5] text-white font-semibold text-sm transition-all hover:-translate-y-0.5 shadow-[0_10px_24px_-8px_rgba(20,184,166,0.55)]"
                    >
                        {socialMediaPlan.cta}
                    </Link>
                </div>
            </div>
        </div>
    );
};
